/**
 * The lifecycle values, as a value rather than a type — zod enums, status
 * filters and select options all need to enumerate them, and each place that
 * retyped the list was a place it could drift from the database enum.
 */
export const CONTENT_STATUSES = ['draft', 'published', 'archived'];
//# sourceMappingURL=content.js.map